<template lang="html">
  <b-card style="padding:40px;">
    <h5><b>SUB DEALER</b></h5>
    <hr />
    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Name</label>
          <b-form-input
            v-model="form.name"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Date Of Birth</label>
          <b-form-input
            v-model="form.dob"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-company`">Company Name</label>
          <b-form-input
            v-model="form.company"
            :id="`input-company`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Role</label>
          <b-form-input
            v-model="form.role"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4" v-if="form.access_lvl != 2">
        <b-form-group>
          <label v-if="form.access_lvl == 3" :for="`input-role`"
            >Stokist Name</label
          >
          <label v-if="form.access_lvl == 4" :for="`input-role`"
            >Home Dealer Name</label
          >
          <b-form-input
            v-model="form.stokist"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="12">
        <b-form-group>
          <label :for="`input-role`">Address</label>
          <b-form-input
            v-model="form.add1"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input
          ><br />
          <b-form-input
            v-model="form.add2"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input
          ><br />
          <b-form-input
            v-model="form.add3"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">State</label>
          <b-form-input
            v-model="form.state"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">City</label>
          <b-form-input
            v-model="form.city"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Postcode</label>
          <b-form-input
            v-model="form.postcode"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Phone Number</label>
          <b-form-input
            v-model="form.phone_no"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Email</label>
          <b-form-input
            v-model="form.email"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <!-- <TableInside
      v-if="this.form.access_lvl != 4"
      :fields="fields.stockist"
      :items="items"
      :state="this.$route.query.state"
      :stockist_id="this.$route.query.stockist_id"
      :type="type"
    /> -->

    <TableStockOutByDay :fields="fields.stockout" :id="this.$route.query.id" />

    <b-row>
      <b-col align="right">
        <b-button variant="primary" size="sm" @click="onClickBack">
          BACK
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
// import TableInside from "@/table/admin/subDealer/TableInside";
// import TableStockoutIndex from "@/table/admin/stockout/TableStockoutIndex";
import TableStockOutByDay from "@/table/user/subDealer/TableStockOutByDay";
export default {
  components: {
    // TableInside,
    // TableStockoutIndex,
    TableStockOutByDay
  },

  data() {
    return {
      form: {
        name: "",
        dob: "",
        access_lvl: "",
        company: "",
        role: "",
        stokist: "",
        chiller: "",
        add1: "",
        add2: "",
        add3: "",
        state: "",
        city: "",
        postcode: "",
        phone_no: "",
        email: ""
      },

      items: [],
      items_stock: [],

      type: "admin",

      fields: {
        stockist: [
          {
            label: "No",
            key: "index",
            sortable: false
          },
          {
            label: "Name",
            key: "name",
            sortable: true
          },
          {
            label: "Role",
            key: "role",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ],
        stockout: [
          {
            label: "No",
            key: "index",
            sortable: false
          },
          {
            label: "Name",
            key: "name",
            sortable: true
          },
          {
            label: "Outlet Name",
            key: "outlet_name",
            sortable: true
          },
          {
            label: "Category",
            key: "category",
            sortable: true
          },
          {
            label: "Date",
            key: "date",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ]
      }
    };
  },

  created() {
    this.showUser();
    // this.getStockoutAdmin();
    // this.getDownlineAdmin();
  },

  methods: {
    showUser() {
      this.$store
        .dispatch("showUser", {
          user_id: this.$route.query.id
        })
        .then(res => {
          if (res.data.response.code === 100) {
            this.form.id = this.$route.query.id;
            this.form.name = res.data.data.name;
            this.form.access_lvl = res.data.data.access_lvl;
            this.form.dob = res.data.data.dob;
            this.form.company = res.data.data.company;
            this.form.role = res.data.data.role_details.desc;
            this.form.chiller = res.data.data.chiller;
            this.form.add1 = res.data.data.add1;
            this.form.add2 = res.data.data.add2;
            this.form.add3 = res.data.data.add3;
            this.form.state = res.data.data.state_details.desc;
            this.form.city = res.data.data.city;
            this.form.postcode = res.data.data.postcode;
            this.form.email = res.data.data.email;
            this.form.phone_no = res.data.data.phone_no;
            this.form.stokist = res.data.data.downline.userdetails.name;
          }
        });
    },

    getDownlineAdmin() {
      this.items = [];
      this.$store
        .dispatch("getIndividualDownline", this.$route.query.id)
        .then(res => {
          if (res.data.response && res.data.response.code === 100) {
            let no = 0;
            res.data.data.forEach(element => {
              no = no + 1;
              this.items.push({
                no: no,
                name: element.name,
                role: element.access_lvl,
                id: element.user_id
              });
            });
          }
        });
    },

    getStockoutAdmin() {
      this.items_stock = [];

      this.$store
        .dispatch("getStockoutSubDAdmin", { user_id: this.$route.query.id })
        .then(res => {
          if (res.data.response && res.data.response.code === 100) {
            let no = 0;
            res.data.data.forEach(element => {
              no = no + 1;
              let outletCat;
              if (element.outlet !== null) {
                outletCat = element.outlet.name;
              }

              let type = element.type === 1 ? "UHT" : "Pasteurized";
              this.items_stock.push({
                no: no,
                user_name: element.userdetails.name,
                name: element.outlet_name,
                category: outletCat,
                date: element.date,
                id: element.stock_id,
                type: element.type,
                pro_cat: type
              });
            });
          }
        });
    },

    onClickBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="css" scoped></style>
